/**
 * Constantes produit Aquapod (Odalie) — barème fourni par l'utilisateur, non rattaché à une
 * API tarifaire externe (même logique que CUVE_TIERS dans le module pluie : à date, non affiné
 * par un devis réel).
 */
export const AQUAPOD_MODELS = [
  { id: '3m3', label: 'Aquapod 3 m³ — 2 cuves 2 m³', dailyCapacityM3: 3, price: 72800 },
  { id: '7m3', label: 'Aquapod 7 m³ — 2 cuves 3 m³', dailyCapacityM3: 7, price: 82800 },
  { id: '15m3', label: 'Aquapod 15 m³ — 2 cuves 5 m³', dailyCapacityM3: 15, price: 102800 },
];

// Part des eaux grises collectées effectivement restituée en eau valorisable après traitement.
export const AQUAPOD_YIELD = 0.8;

export const PLUMBING_COST_PER_POINT = 300;
export const MAINTENANCE_COST_PER_YEAR = 6000;
export const OPERATING_DAYS_PER_YEAR = 365;

export const DEFAULT_NETWORK_WATER_PRICE = 5.5;

/**
 * Capacité annuelle de traitement d'un modèle Aquapod, en m³ — plafond amont indépendant
 * du rendement (le rendement s'applique au gisement collecté, pas à la capacité machine).
 */
export const computeAnnualCapacity = (model) => model.dailyCapacityM3 * OPERATING_DAYS_PER_YEAR;

export const fmtEUR = (n) => Math.round(n).toLocaleString('fr-FR');
